export const WORD_CLOUD_SENTIMENT_EXTRAS = {
  refund: -3,
  refunds: -3,
  chargeback: -3,
  return: -2,
  returns: -2,
  exchange: -1,
  cancel: -2,
  cancelled: -2,
  canceled: -2,
  cancellation: -2,
  delayed: -3,
  delay: -3,
  delays: -3,
  late: -2,
  missing: -3,
  lost: -2,
  broken: -3,
  damaged: -3,
  defective: -3,
  wrong: -2,
  incorrect: -2,
  complaint: -3,
  complaints: -3,
  complain: -2,
  frustrated: -3,
  angry: -3,
  rude: -3,
  terrible: -3,
  awful: -3,
  horrible: -3,
  worst: -3,
  unhappy: -3,
  disappointed: -3,
  disappointment: -3,
  unacceptable: -3,
  scam: -4,
  fraud: -4,
  stolen: -3,
  overcharged: -3,
  overcharge: -3,
  issue: -2,
  issues: -2,
  problem: -2,
  problems: -2,
  error: -2,
  errors: -2,
  fail: -2,
  failed: -2,
  failure: -2,
  useless: -3,
  worthless: -3,
  thanks: 2,
  thank: 2,
  grateful: 3,
  appreciate: 2,
  appreciated: 2,
  excellent: 3,
  amazing: 3,
  wonderful: 3,
  perfect: 3,
  helpful: 2,
  satisfied: 2,
  satisfaction: 2,
  recommend: 2,
  resolved: 2,
  fixed: 2,
  kindly: 2,
};
